import { MapPin, Heart, Users, Dog } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

export const FacebookCover = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <GraphicBackground
      width={1640}
      height={624}
      bgImage={bgImage}
      backgroundPosition="center"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 80px",
        gap: "80px",
      }}
    >
      {/* Left side - icon + text */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "40px",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: "160px",
            height: "160px",
            background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
            borderRadius: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 8px 32px rgba(78,138,110,0.3)",
            flexShrink: 0,
          }}
        >
          <MapPin style={{ width: "80px", height: "80px", color: "#FFFFFF" }} />
        </div>

        {/* Text */}
        <div>
          <h1
            style={{
              fontSize: "72px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              lineHeight: 1.1,
              whiteSpace: "nowrap",
            }}
          >
            Mapa Schronisk
          </h1>
          <h1
            style={{
              fontSize: "72px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              lineHeight: 1.1,
              whiteSpace: "nowrap",
            }}
          >
            dla Zwierząt
          </h1>
        </div>
      </div>

      {/* Right side - feature pills */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          flexShrink: 0,
        }}
      >
        {[
          { icon: Heart, text: "Aktualne potrzeby" },
          { icon: Users, text: "Wolontariat" },
          { icon: Dog, text: "Spacery z psami" },
        ].map((f) => (
          <div
            key={f.text}
            style={{
              background: "rgba(255,255,255,0.92)",
              padding: "18px 36px",
              borderRadius: "50px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            }}
          >
            <f.icon style={{ width: "28px", height: "28px", color: "#4E8A6E" }} />
            <span style={{ fontSize: "26px", fontWeight: 700, color: "#2D5A3D" }}>
              {f.text}
            </span>
          </div>
        ))}
      </div>
    </GraphicBackground>
  );
};

